<template>
  <ErrorPage :status-message="error.statusMessage" :cause="error.cause" />
</template>

<script setup>
import ErrorPage from '../frontend/src/pages/ErrorPage.vue';

definePageMeta({
  layout: false
});

const props = defineProps({
  error: {
    type: Object,
    required: true
  }
});

console.error(props.error);
</script>
